import {z} from 'zod'

export const settingsSchema = z.object({
  instantFeedback: z.boolean().default(true),
  shuffleQuestions: z.boolean().default(false),
  showProgressBar: z.boolean().default(true),
  primaryColor: z.string().default('#6c5ce7'),
})

export type ClassicQuizSettings = z.infer<typeof settingsSchema>
